import { $, $$ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";
import { CSS } from "@constants/css-classes";

/**
 * Initialize accessible dropdown menu functionality
 */
export function initDropdowns(): void {
  const dropdowns = $$(DATA_ATTR.DROPDOWN);

  dropdowns.forEach((dropdown) => {
    const trigger = $<HTMLButtonElement>(DATA_ATTR.DROPDOWN_TRIGGER, dropdown);
    const menu = $(DATA_ATTR.DROPDOWN_MENU, dropdown);
    const icon = $(DATA_ATTR.DROPDOWN_ICON, dropdown);

    if (!trigger || !menu) return;

    const openDropdown = (): void => {
      trigger.setAttribute("aria-expanded", "true");
      menu.classList.remove(CSS.OPACITY_0, CSS.INVISIBLE, CSS.TRANSLATE_Y_1);
      menu.classList.add(CSS.OPACITY_100, CSS.VISIBLE, CSS.TRANSLATE_Y_0);
      icon?.classList.add(CSS.ROTATE_180);
    };

    const closeDropdown = (): void => {
      trigger.setAttribute("aria-expanded", "false");
      menu.classList.add(CSS.OPACITY_0, CSS.INVISIBLE, CSS.TRANSLATE_Y_1);
      menu.classList.remove(CSS.OPACITY_100, CSS.VISIBLE, CSS.TRANSLATE_Y_0);
      icon?.classList.remove(CSS.ROTATE_180);
    };

    const toggleDropdown = (): void => {
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        closeDropdown();
      } else {
        // Close all other dropdowns first
        dropdowns.forEach((other) => {
          if (other !== dropdown) {
            const otherTrigger = $<HTMLButtonElement>(
              DATA_ATTR.DROPDOWN_TRIGGER,
              other
            );
            const otherMenu = $(DATA_ATTR.DROPDOWN_MENU, other);
            const otherIcon = $(DATA_ATTR.DROPDOWN_ICON, other);
            if (otherTrigger && otherMenu) {
              otherTrigger.setAttribute("aria-expanded", "false");
              otherMenu.classList.add(
                CSS.OPACITY_0,
                CSS.INVISIBLE,
                CSS.TRANSLATE_Y_1
              );
              otherMenu.classList.remove(
                CSS.OPACITY_100,
                CSS.VISIBLE,
                CSS.TRANSLATE_Y_0
              );
              otherIcon?.classList.remove(CSS.ROTATE_180);
            }
          }
        });
        openDropdown();
      }
    };

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      toggleDropdown();
    });

    // Keyboard navigation
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleDropdown();
      }
      if (e.key === "Escape") {
        closeDropdown();
        trigger.focus();
      }
    });

    menu.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeDropdown();
        trigger.focus();
      }
    });

    // Close on click outside
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target as Node)) {
        closeDropdown();
      }
    });
  });
}
